/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/prop-types */

import { ICellTextProps } from "ka-table/props";
import React from "react";
import { dateFormat, getValueForRow } from "../../utils/tableUtils";
import { Tooltip } from "@mantine/core";
import { format } from "date-fns";
import { zonedTimeToUtc } from "date-fns-tz";

const DateCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, dispatch, rowKeyValue, ...props
  }) => {
    const value = props.rowData[`${column.key}`];
    if (!value) {
      return <span className="text-sm text-gray-400">—</span>;
    }
    try {
      return (
        <Tooltip label={format(zonedTimeToUtc(new Date(String(value).replace(" ", "T")), "UTC"), "dd MMM yyyy h:mm aa")} position="bottom">
          <div className="overflow-hidden text-ellipsis whitespace-nowrap text-sm">
            {dateFormat(column.key, String(value))}
          </div>
        </Tooltip>
      );
    } catch {
      return <span className="text-sm text-gray-500">{String(value)}</span>;
    }
  },
);

export default DateCell;
